type Event = {
  name: string;
  payload: any;
};

type Listener = {
  eventName: string;
  callbackFns: Array<Function>;
};

type Listeners = Array<Listener>;

class EventEmitter {
  listeners: Listeners;

  constructor() {
    this.listeners = [];
  }

  subscribe = (eventName: string, callbackFn: Function) => {
    let listener = this.listeners.find((x) => x.eventName === eventName);

    if (listener === null || listener === undefined) {
      this.listeners.push({
        eventName,
        callbackFns: [],
      });

      listener = this.listeners.find((x) => x.eventName === eventName);
    }

    listener.callbackFns.push(callbackFn);
  };

  unsubscribe = (eventName: string, callbackFn: Function) => {
    const listener = this.listeners.find((x) => x.eventName === eventName);

    if (listener !== null && listener !== undefined) {
      const callbackIndex = listener.callbackFns.findIndex(
        (x) => x === callbackFn
      );

      if (callbackIndex !== -1) {
        listener.callbackFns.splice(callbackIndex, 1);

        if (listener.callbackFns.length === 0) {
          const listenerIndex = this.listeners.findIndex(
            (x) => x.eventName === eventName
          );

          this.listeners.splice(listenerIndex, 1);
        }
      }
    }
  };

  publish = (event: Event) => {
    const listener = this.listeners.find((x) => x.eventName === event.name);

    if (listener !== null && listener !== undefined) {
      listener.callbackFns.forEach((callbackFn) => {
        callbackFn.call(this, event.payload);
      });
    }
  };
}

export default EventEmitter;
